<template>
  <div class="formZR">
    <span v-show="type === 'add'" style="font-size: 20px">*為必須填寫項目</span>
    <div class="rowDiv" style="display: flex;">
      <div class="row">
        <span class="left">姓氏</span>
        <input class="first_name right" v-model="formData.first_name" placeholder="*">
      </div>
      <div class="row">
        <span class="left">名字</span>
        <input class="last_name right" v-model="formData.last_name" placeholder="*">
      </div>
      <div class="row">
        <span class="left">郵箱</span>
        <input class="email right" v-model="formData.email" placeholder="*郵箱地址">
      </div>
      <div class="row">
        <select class="left" v-model="formData.area_code" style="letter-spacing:0; border-radius: 0 !important;">
          <option v-for="row in areaCodeList" :label="row.label" :value="row.value">{{row.label}}</option>
        </select>
        <input class="mobile right" v-model="formData.mobile" placeholder="*手機號">
      </div>
      <div class="row">
        <select class="right" v-model="areaList1" @change="areaListChange(1)">
          <option :value="[]" disabled selected>*省</option>
          <option v-for="row in areaList" :value="row">{{ row.name }}</option>
        </select>
        <span style="width: 5px"></span>
        <select class="right" v-model="areaList2" @change="areaListChange(2)">
          <option :value="[]" disabled selected>*市</option>
          <option v-for="row in areaList1.cities" :value="row">{{ row.name }}</option>
        </select>
        <span style="width: 5px"></span>
        <select class="right" v-model="areaList3">
          <option :value="null" disabled selected>*區</option>
          <option v-for="row in areaList2.districts" :value="row">{{ row.name }}</option>
        </select>
      </div>

      <div class="row">
        <input class="address right" v-model="formData.address" placeholder="*請填寫詳細地址">
      </div>
      <div class="row">
        <el-button class="saveAddressButton" @click="saveAddress">保存地址</el-button>
        <el-button class="cancelAddressButton" @click="$emit('cancel')">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import Validator from "../assets/js/Validator";
  export default {
    name: "AddressForm",
    props: [ 'type', 'addressForm', 'areaList', 'areaCodeList'],
    data(){
      return{
        formData: {
          first_name: '',
          last_name: '',
          name: '',
          gender: 'f',
          area_code: '852',
          map_x: 0,
          map_y: 0,
          mobile: '',
          email: '',
          is_default: 0,
          district_id: '',
          address: '',
        },
        areaList1: [],
        areaList2: [],
        areaList3: null,
      }
    },
    methods: {
      areaListChange(level) {
        if (level === 1) {
          this.areaList2 = [];
        }
        this.areaList3 = null;
      },
      formValidator() {
        if (!this.formData.first_name) {
          this.$notify.error({title: '錯誤', message: '請填寫姓氏'});
          $('.first_name').focus();
          return false;
        }
        if (!this.formData.last_name) {
          this.$notify.error({title: '錯誤', message: '請填寫名字'});
          $('.last_name').focus();
          return false;
        }
        if (!Validator('email',{ email: this.formData.email })) {
          return false;
        }
        if (!Validator('mobile',{ mobile: this.formData.mobile, areaCode: this.formData.area_code })) {
          return false;
        }
        if (!this.areaList3 || !this.formData.address) {
          this.$notify.error({title: '錯誤', message: '請選擇地區並填寫詳細地址'});
          $('.address').focus();
          return false;
        }
        this.formData.name = this.formData.first_name + ' ' + this.formData.last_name;
        this.formData.district_id = this.areaList3.id;
        return true;
      },
      saveAddress() {
        if (this.formValidator()) {
          switch (this.type) {
            case 'add':
              this.formData.is_default = 1;
              this.$axios.post('api/app_v1/customer/addresses', this.formData).then(res => {
                this.$notify.success({ message: '保存成功' });
                this.$emit('reload');
              });
              break;
            case 'edit':
              this.$axios.put('api/app_v1/customer/addresses/' + this.formData.id, this.formData).then(res => {
                this.$notify.success({ message: '保存成功' });
                this.$emit('reload');
              });
              break;
          }
        }
      },
    },
    created() {
      if (this.addressForm && this.addressForm.id) {
        this.formData = JSON.parse(JSON.stringify(this.addressForm));
        let areaIds = this.formData.address_path.split('-');
        /*this.areaList.map(item1 => {
          item1.cities.map(item2 => {
            item2.districts.map(item3 => {
              if (item3.id == areaIds[2]) {
                this.areaList1 = item1;
                this.areaList2 = item2;
                this.areaList3 = item3;
              }
            })
          })
        });*/
        this.areaList.map(item => {
          if (item.id == areaIds[0]) {
            this.areaList1 = item;
            item.cities.map(item => {
              if (item.id == areaIds[1]) {
                this.areaList2 = item;
                item.districts.map(item => {
                  if (item.id == areaIds[2]) {
                    this.areaList3 = item;
                  }
                })
              }
            })
          }
        })
      }
    },
  }
</script>

<style scoped>
  .rowDiv {
    flex-wrap: wrap;
  }
  .formZR {
    /*height: 564px;*/
  }
  .formZR .row {
    width: 100%;
  }
  .formZR .el-button {
    border-radius: 0;
    height: 52px;
    font-size: 20px;
  }
  .formZR .saveAddressButton {
    background:rgba(231,204,152,1);
    color: #FFFFFF;
  }
  .formZR .cancelAddressButton {
    color: #635C50;
  }
  .row {
    display: flex;
    color: #1E1303;
    margin: 9px 0 6px 0;
  }
  .row .left{
    font-size: 20px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(231,231,231,1);
    height: 52px;
    line-height: 52px;
    padding: 0 5px;
    box-sizing: border-box;
    width: 82px;
    letter-spacing:5px;
    text-align: center;
    margin-right: 5px;
  }
  .row .right{
    font-size: 20px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(231,231,231,1);
    height: 52px;
    line-height: 52px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/AddressForm.vue